const i = (a, c) => {
  var r, n;
  const o = ((n = (r = c.maps) == null ? void 0 : r[a]) == null ? void 0 : n.layerGroupConfig) || {};
  let e = {};
  return Object.values(o).forEach(({ subLayerConfig: t }) => {
    t && (e = {
      ...e,
      ...t
    });
  }), {
    ...o,
    ...e
  };
};
export {
  i as getCombinedLayerConfig
};
//# sourceMappingURL=index.es27.js.map
